export default __webpack_public_path__ + "static/media/franchise1.1ae74fce.jpg";